import { Model } from 'modules/core/lib/mobx-rest'

interface IAssignment {
  id: string
  access_id: string
}

class Assignment extends Model<IAssignment> {
  static urlRoot() {
    return '/complaints/assignments'
  }
}

export default Assignment
